import { useLazyLoadQuery } from 'react-relay';
import { graphql } from 'relay-runtime';
import type { getTrelloWorkspacesQuery } from '#generated/graphql/getTrelloWorkspacesQuery.graphql';
import type { TrelloWorkspace } from './trelloTypes';

const query = graphql`
  query getTrelloWorkspacesQuery {
    trello {
      me @optIn(to: "TrelloMe") {
        workspaces(first: 10) {
          edges {
            node {
              id
              displayName
              enterprise {
                atlassianOrganization {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * Fetches the current user's Trello workspaces via AGG.
 *
 * Returns an array of {@link TrelloWorkspace} objects. The query is suspended
 * by Relay while loading.
 */
export function useTrelloWorkspaces(): TrelloWorkspace[] {
  const data = useLazyLoadQuery<getTrelloWorkspacesQuery>(query, {});

  const edges = data.trello?.me?.workspaces?.edges ?? [];
  return edges
    .map((edge) => edge?.node)
    .filter(
      (
        node,
      ): node is {
        readonly id: string;
        readonly displayName: string | null;
        readonly enterprise:
          | {
              readonly atlassianOrganization:
                | { readonly id: string }
                | null
                | undefined;
            }
          | null
          | undefined;
      } => node != null && node.id != null,
    )
    .map((node) => ({
      id: node.id,
      displayName: node.displayName ?? node.id,
      atlassianOrganizationId:
        node.enterprise?.atlassianOrganization?.id ?? null,
    }));
}
